import type { StateCreator } from 'zustand';
import type { UserSettings } from '@abs/shared-types';

export interface SettingsSlice {
  settings: UserSettings;

  updateSettings: (updates: Partial<UserSettings>) => void;
  completeOnboarding: () => void;
  setTheme: (theme: UserSettings['theme']) => void;
}

const DEFAULT_SETTINGS: UserSettings = {
  theme: 'system',
  defaultPolicyId: null,
  onboardingCompleted: false,
  backupReminderLastShown: null,
  highContrast: false,
  largeText: false,
  demoLoaded: false,
  showLoadDemo: true,
};

export const createSettingsSlice: StateCreator<SettingsSlice> = (set) => ({
  settings: { ...DEFAULT_SETTINGS },

  updateSettings: (updates) => {
    set((state) => ({
      settings: { ...state.settings, ...updates },
    }));
  },

  completeOnboarding: () => {
    set((state) => ({
      settings: { ...state.settings, onboardingCompleted: true },
    }));
  },

  setTheme: (theme) => {
    set((state) => ({
      settings: { ...state.settings, theme },
    }));
  },
});
